function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MenuContext } from './SelectMenuContext';
import SelectMenuList from './SelectMenuList';
import theme from '../theme';
import { COMMON, get } from '../constants';
import sx from '../sx';

const TabPanelBase = ({
  tabName,
  className,
  children,
  ...rest
}) => {
  const menuContext = useContext(MenuContext);
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tabpanel",
    className: className,
    hidden: menuContext.selectedTab !== tabName
  }, rest), /*#__PURE__*/React.createElement(SelectMenuList, null, children));
};

TabPanelBase.displayName = "TabPanelBase";
const TabPanel = styled(TabPanelBase).withConfig({
  displayName: "SelectMenuTabPanel__TabPanel",
  componentId: "hgx3vc-0"
})(["border-top:", " solid ", ";", " ", ";"], get('borderWidths.1'), get('colors.border.gray'), COMMON, sx);
TabPanel.defaultProps = {
  theme
};
TabPanel.propTypes = {
  tabName: PropTypes.string,
  ...COMMON.propTypes,
  ...sx.propTypes
};
TabPanel.displayName = 'SelectMenu.TabPanel';
export default TabPanel;